import { Pagination } from "@heroui/react";

const DataTablePagination = ({ table }) => {
    const { meta, pagination, isLoading } = table;
    const totalPages = meta?.lastPage || 1;

    return (
        <div className="flex w-full flex-col items-center justify-end gap-4 p-4 sm:flex-row">
            <Pagination
                total={totalPages}
                page={meta.currentPage}
                onChange={pagination.setPage}
                showControls
                color="primary"
                size="sm"
                siblings={1}
                boundaries={1}
                isDisabled={isLoading}
            />
        </div>
    );
};

export default DataTablePagination;
